import algoliasearch from 'algoliasearch/dist/algoliasearch-lite.umd';
import instantsearch from 'instantsearch.js';
import { configure, hits } from 'instantsearch.js/es/widgets';
import { highlight, snippet } from 'instantsearch.js/es/helpers';
// global algoliasearch, instantsearch
export function initSearch() {
    let search;
    let helper;

    // Algolia API credentials to setup InstantSearch.js
    const ALGOLIA_SEARCH = {
        appId: '6RCFK5TOI5',
        apiKey: '521c444a09acd62368618fce7f15dafa',
        indexName: 'G4_TUTORIALS',
    };

    const initInstantSearch = () => {
        const searchClient = algoliasearch(
            ALGOLIA_SEARCH.appId,
            ALGOLIA_SEARCH.apiKey,
        );

        search = instantsearch({
            indexName: ALGOLIA_SEARCH.indexName,
            searchClient,
            searchFunction(helper) {
                const container = document.querySelector('#hits');
                container.style.display =
                    helper.state.query === '' ? 'none' : '';

                if (helper.state.query) {
                    helper.search();
                }
            },
        });

        search.addWidgets([
            {
                init(opts) {
                    helper = opts.helper;
                    const input = document.querySelector('#search-input');
                    input.addEventListener('input', ({ currentTarget }) => {
                        helper
                            .setQuery(currentTarget.value) // update the parameters
                            .search(); // launch the query

                        if (currentTarget.value) {
                            document.body.classList.add('search-active');
                            document.getElementById(
                                'reset-search',
                            ).style.display = 'flex';
                        } else {
                            document.body.classList.remove('search-active');
                            document.getElementById(
                                'start-search',
                            ).style.display = 'flex';
                            document.getElementById(
                                'reset-search',
                            ).style.display = 'none';
                        }
                    });
                },
                render({ state }) {
                    // Handle rendering widgets based on query and results
                    document.getElementById('hits').style.display = 'initial';

                    if (!state.query || state.query.length < 1) {
                        document.getElementById('hits').style.display = 'none';
                    }
                },
            },
            configure({
                attributesToSnippet: ['html:20'],
            }),
            hits({
                container: '#hits',
                cssClasses: {
                    root: 'search-results',
                    list: 'search-results-list',
                    emptyRoot: 'search-empty-results',
                    item: 'search-result-item',
                },
                templates: {
                    empty: 'No results found',
                    item(hit) {
                        return `<a class="search-result-link" href="${hit.url}">
                                <span class="tag-${
                                    hit.tags.length &&
                                    hit.tags[0].slug
                                }">${
                            hit.tags.length &&
                            hit.tags[0].name
                        }</span>
                                <div class="search-result-content">
                                    <span>${highlight({
                                        attribute: 'title',
                                        hit,
                                    })}</span>
                                    <p>${snippet({
                                        attribute: 'html',
                                        hit,
                                    })}...</p>
                                </div>
                            </a>`;
                    },
                },
            }),
        ]);

        search.start();
    };

    // Bootup instantSearch

    function placeholderResize() {
        const placeholderWide =
            'Search all Ghost tutorials...';
        const placeholderSmall = 'Search all tutorials...';
        const placeholderTiny = 'Search tutorials...';

        if (window.innerWidth < 400) {
            document
                .getElementById('search-input')
                .setAttribute('placeholder', placeholderTiny);
        } else if (window.innerWidth < 480) {
            document
                .getElementById('search-input')
                .setAttribute('placeholder', placeholderSmall);
        } else {
            document
                .getElementById('search-input')
                .setAttribute('placeholder', placeholderWide);
        }
    }

    if (
        document.getElementById('search-input') &&
        document.getElementById('hits')
    ) {
        //     // Only render search where it should be
        initInstantSearch();

        placeholderResize();

        document.documentElement.addEventListener('keyup', (e) => {
            if (
                e.code === 27 &&
                document.body.classList.contains('search-active')
            ) {
                document.getElementById('search-input').value = '';
                document.body.classList.remove('search-active');
                document.getElementById('reset-search').style.display = 'none';
                document.getElementById('start-search').style.display = 'flex';

                helper
                    .setQuery('') // update the parameters
                    .search(); // launch the query
            }
        });

        window.addEventListener('resize', placeholderResize);

        document
            .getElementById('start-search')
            .addEventListener('click', (e) => {
                e.preventDefault();
                document.getElementById('search-input').focus();
            });

        document
            .getElementById('reset-search')
            .addEventListener('click', (e) => {
                e.preventDefault();
                document.getElementById('search-input').value = '';
                document.body.classList.remove('search-active');

                document.getElementById('reset-search').style.display = 'none';
                document.getElementById('start-search').style.display = 'flex';

                helper
                    .setQuery('') // update the parameters
                    .search(); // launch the query
            });
    }
}
